import { createFileRoute } from '@tanstack/react-router';

import { OwnerEditorPage } from '../features/demand/owners/components/OwnerEditorPage';

export const Route = createFileRoute('/demand/owners/create')({
  component: OwnerCreateRoute,
});

function OwnerCreateRoute() {
  return <OwnerEditorPage />;
}
